import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHome = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M15 16.9059C15.8284 16.9059 16.5 16.2343 16.5 15.4059L16.5 8.42929C16.4999 8.25585 16.4638 8.08432 16.3939 7.92561C16.3239 7.7669 16.2217 7.62448 16.0938 7.50741L9.84375 1.82773C9.61332 1.61691 9.31231 1.5 9 1.5C8.68768 1.5 8.38668 1.61691 8.15625 1.82773L1.90625 7.50741C1.77828 7.62448 1.67608 7.7669 1.60614 7.92561C1.5362 8.08432 1.50006 8.25585 1.5 8.42929L1.50005 15.4059C1.50006 16.2343 2.17163 16.9059 3.00005 16.9059H15ZM2.75 8.42929L9 2.7496L15.25 8.42929V15.6559H11.5V11.9059C11.5 11.5743 11.3683 11.2564 11.1339 11.022C10.8995 10.7875 10.5815 10.6559 10.25 10.6559H7.75C7.41848 10.6559 7.10054 10.7875 6.86612 11.022C6.63169 11.2564 6.5 11.5743 6.5 11.9059V15.6559H2.75V8.42929ZM10.25 15.6559H7.75V11.9059H10.25V15.6559Z",
		fill: "white"
	})]
});
const ForwardRef = forwardRef(SvgHome);
export { ForwardRef as ReactComponent };
